export default __webpack_public_path__ + "fdba095a5fb561f422d57fbfff9019cb.png";